<div class="dynamic-input-array">
  <h3 for="occurrences">
    {{ dynamicCMInputArray.input_name }}
    <input
      id="occurrences"
      type="number"
      [value]="dynamicCMInputArray.default_inputs_amount"
      (input)="onInputOccurrenceChange($event)"
      min="{{ dynamicCMInputArray.minimum_inputs_amount }}"
      max="{{ dynamicCMInputArray.maximum_inputs_amount }}"
    />
  </h3>
  @if (dynamicCMInputArray.input_description) {
    <p [innerHTML]="dynamicCMInputArray.input_description"></p>
  }

  @for (input of dynamicCMInputArray.ArrayOfRegularInput; track $index) {
    <app-cm-input
      [cmInput]="input"
      [index]="$index"
      [isInputsArrayTemplate]="true"
      (inputValueChangedNotifier)="onChildInputValueChange($event)"
    ></app-cm-input>
  }
</div>
